import { z } from 'zod';

export const QcStatusByDetectedIssuesDecisions = z.enum(['GOOD', 'BAD', 'NEEDS_REVIEW']);
export type QcStatusByDetectedIssuesDecisionsType = z.infer<typeof QcStatusByDetectedIssuesDecisions>;
